import { DatePipe, NgClass } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { ExchangeRatesService } from 'src/app/shared/services/rates.service';
import { PageData } from 'src/app/shared/models/page-data.model';
import { PageDataService } from 'src/app/shared/services/page-data.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Rate } from 'src/app/shared/models/rate';
import { CurrencyRateCellComponent } from 'src/app/landing/components/rates/currency-rate-cell/currency-rate-cell.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AlertButtonComponent } from 'src/app/features/rates/components/alert-button/alert-button.component';
import { RateUtils } from 'src/app/shared/utils/rate.utils';

@Component({
  selector: 'app-rates',
  imports: [DatePipe, NgClass, CurrencyRateCellComponent, MatProgressSpinnerModule, AlertButtonComponent],
  templateUrl: './rates.component.html',
  styleUrl: './rates.component.scss',
})
export class RatesComponent implements OnInit {
  private readonly ratesService = inject(ExchangeRatesService);
  private readonly pageDataService = inject(PageDataService);
  private readonly sanitizer = inject(DomSanitizer);

  updatedAt?: Date;
  rates: Rate[] = [];
  existSummarizedRate = false;
  rateNotes?: PageData;

  async ngOnInit() {
    // get latest rates
    const cadLastRates = await this.ratesService.lastRate(undefined, 'CAD');
    // find latest updated rate
    this.updatedAt = new Date(Math.max(...cadLastRates.map((e) => new Date(e.updatedAt).getTime())));

    this.rates = cadLastRates.map((it) => {
      this.existSummarizedRate = this.existSummarizedRate || !!it.details?.webSummarizedMode;
      return RateUtils.prepareRate(it);
    });

    this.rateNotes = await this.pageDataService.getPageData('landing', 'rate-notes');
    this.rateNotes.data = this.sanitizer.bypassSecurityTrustHtml(this.rateNotes.data as string);
  }
}
